<template>
  <transition>
    <div class="center-content">
      <div
        class="flight-search-wrapper"
        :class="{ mlcity_wrap : isMLSearch}"
        @click="isPaxViewOpen=false"
      >
        
        
        <div class="main-search">
          <!-- <cMLSearch v-if="isMLSearch" :searchMlObj="search"/> -->

          <div v-if="!isMLSearch" class="route-name-wrapper">
            <div v-if="hotelSearch.areaObj" class="place">
              
              <div class="form">
                <label class="typo__label">{{$t('hotelSearch.goinPlace')}}</label>
                <multiselect
                  :allow-empty="false"
                  :showLabels="false"
                  :clearOnSelect="false"
                  v-model="hotelSearch.areaObj.cityName"
                  :options="lsCountryRoute"
                  :multiple="false"
                  group-values="routeList"
                  group-label="country"
                  :group-select="false"
                  :placeholder="$t('searchPage.searchPlaceHolder')"
                  track-by="code"
                  
                  v-on:close="openDatePicker"
                  v-on:open="triggerFlightDatePicker"
                  ref="fromCityPicker"
                  :searchable="true"
                  :custom-label="cityPickCustomeLabel"
                  @search-change="addCssClass()"
                >
                  <template
                    slot="singleLabel"
                    slot-scope="{ option }"
                  >{{ option.cityname}} ({{option.code}})</template>
                  <template slot="option" slot-scope="props">
                    <div>
                      <span v-if="props.option.$isLabel &&routesResponse && routesResponse.Country ">
                        
                        
                        {{ routesResponse.Country[props.option.$groupLabel].value}}</span>
                      <span v-else>
                        {{ props.option.cityname}}
                        <strong
                          v-if="props.option.code"
                          class="right"
                        >{{ props.option.code }}</strong>
                      </span>
                    </div>
                  </template>
                  <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                </multiselect>
              </div>
              
            </div>
            <div
              class="date"
              @click="closePaxView()"
            >
              <label class="typo__label depart">{{$t('hotelSearch.checkIn')}}</label>
              <label class="typo__label return">{{$t('hotelSearch.checkOut')}}</label>

              <HotelDatePicker
                v-if="isDatePicShow"
                :showYear="true"
                :hoveringTooltip="false"
                :displayClearButton="false"
                format="dddd, MMM DD"
                @check-in-changed="getFromDate"
                @check-out-changed="getToDate"
                :singleDaySelection="false"
                :i18n="assigni18nObjByLang()"
                ref="flightDatePicker"
                :minNights="0"
              />
            </div>
          </div>

          <div class="currency place" id="currency">
            <cOrgCurrencyDp
            
                v-if="GET_ORG_CURRENCY_RES"
              v-on:input="onCurrencyChange"
              :selValue="hotelSearch.currencyObj"
              :label="$t('searchPage.currName')"
              :ctrlCode="'id'"
              :isAllowEmpty="false"
              :isShowCode="true"
              :isMultiple="false"
              :isSearchable="false"
              :url="getOrgCurrencyServiceURL()"
              rules="required"
              :defaultCurrency="defaultCurrencyCode"
            />
          </div>
          <div @click.stop="isPaxViewOpen=!isPaxViewOpen,onToggleBackdrop(true)" class="passagers">
            <label class="d-flex">
              <span>{{$t('hotelSearch.guest')}}</span>
            </label>
            <div class="value" id="pax">
                <span>{{hotelSearch.roomCount+' '}}</span>
                <span>{{getPaxDisplayText(hotelSearch.roomCount,false)}}</span> ,
              <span v-if="hotelSearch.guestList && hotelSearch.guestList.length!=0">{{getPaxCount(hotelSearch.guestList)}}</span>
              <span>{{getPaxDisplayText(getPaxCount(hotelSearch.guestList),true)}}</span>
            </div>
          </div>
          <div class="pax-wrap" :class="{'d-none remove':!isPaxViewOpen}">
            <div class="pax">
              <div @click.stop="isPaxViewOpen=true" class="content">
                <div class="title">
                  <CRow class="title">
                    <br />
                    <strong>Rooms</strong>
                    <br />
                    <br />
                  </CRow>
                </div>
                <!-- <div class="des">{{$t('searchPage.paxDesc')}}</div> -->

                <!-- <CAlert
                  color="info"
                  v-if="(search.pax.adultCount+search.pax.childCount+search.pax.infantCount)>=9"
                >{{$t('searchPage.maxPax')}}</CAlert> -->
                <div :class="{removeHoverFlight: isHoveringRf == true && hotelSearch.guestList && hotelSearch.guestList.length>roomLength.min}" class="ml-route-wrapper">
                <div v-for="(guests,gindex) in hotelSearch.guestList" :key="'guestList'+gindex" class="row category">
                  
                  <div class="col option">
                    <div class="left">
                      <div class="sub-title">{{$t('searchPage.adult')}}(12+)</div>
                      <br />
                      <!-- <div class="sub-dec">{{$t('searchPage.above')}} 12</div> -->
                    </div>

                    <div class="right">
                      <number-input
                        v-model="guests.adult"
                        :min="1"
                        :max="guests.adult+getMaxPaxCount(guests)"
                        size="small"
                        inline
                        center
                        controls
                        :inputtable="false"
                      ></number-input>
                    </div>
                  </div>
                  <div class="col option">
                    <div class="left">
                      <div class="sub-title">{{$t('searchPage.child')}}(2-11)</div>
                      <br />
                      <!-- <div class="sub-dec">2-12 {{$t('searchPage.years')}}</div> -->
                    </div>
                    <div class="right">
                      <number-input
                        v-model="guests.child"
                        :min="0"
                        :max="guests.child+getMaxPaxCount(guests)"
                        size="small"
                        inline
                        center
                        controls
                        :inputtable="false"
                      ></number-input>
                    </div>
                  </div>
                  <div class="col option">
                    <div class="left">
                      <div class="sub-title">{{$t('searchPage.infants')+' '}}{{$t('hotelSearch.infants')}} </div>
                      <br />
                      <!-- <div class="sub-dec">{{$t('searchPage.below')+' '+2+' '+$t('searchPage.years')}}</div> -->
                    </div>
                    <div class="right">
                      <number-input
                        v-model="guests.infant"
                        :min="0"
                        :max="  getMaxPaxCount(guests)"
                        size="small"
                        inline
                        center
                        controls
                        :inputtable="false"
                      ></number-input>
                    </div>
                  </div>
                   <div class="remove-flight-btn-wrap" v-if="hotelSearch.guestList && (hotelSearch.guestList.length>roomLength.min) && gindex==hotelSearch.guestList.length-1"
                     @click="onRemoveRooms" @mouseover="isHoveringRf = true" @mouseout="isHoveringRf = false">
                    <img src="@/assets/mf/img/svg/icons/cross-red.svg" alt="" style="width:10px;height:10px;">
                </div>
                </div>
                
               
                </div>
                 
                <div class="">
                  <div v-if="hotelSearch.guestList.length<roomLength.max" class="d-flex">
                    <div class="add-ml-flight" 
                    :class="{disable : hotelSearch.guestList.length>=roomLength.max}" @click="addRooms">
                      <img
                        src="@/assets/mf/img/svg/icons/blue-icons/circle_add.svg"
                        alt
                        style="width:25px;height:30px;"
                      />
                      {{'Add Rooms'}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div @click="emitSearchObj" class="search-btn">
            <span class="dot"></span>
            <span>{{$t('searchPage.searchBtn')}}</span>
          </div>
        </div>
      </div>
        <!-- v-if="alertValue==$t('searchPage.routeInvalid')" -->

      <div v-if="alertValue"
        :show="alertValue!=null"
        class="search_error_message"
      >{{alertValue}}</div>
    </div>
  </transition>
</template>

<script>
import Vue from "vue";
import { handleJWT, getErrorAlertValue } from "../../../../util/util";

import {
  getHotelSearchHisFromLocal,
  setHotelSearchHisToLocal,
} from "./../../../../applocalstorage/localStorage";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import {
  dateFunctions,
  getDiffBtwDates,
  addDays,
  formatDate,
} from "../../../../util/date/dateFunctions";
import cCurrencyDropDown from "./../../../currency/cCurrencyDropDown";

import {
  TRIP,
  PAX,
  PAX_COUNT,
  LOCAL_STORAGE_KEYS,
  CITIZEN,
  TOAST_TYPE,
  ALL_CLIENT_CODE,
} from "../../../../util/constants.js";
import cRadioButton from "./../../../form/cRadioButton";
import cOrgCurrencyDp from "./../../../currency/cOrgCurrencyDp";

import Logger from "../../../../services/logger";
import apiGetCitiesforHotel from "../../../../services/apiGetCitiesforHotel.js";
// import apiSearchResult from "../../../../services/apiSearchResult.js";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, {
  navigate,
  goBack,
  updateDataEdited,
} from "../../../../router/index";

import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME } from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base.js";
import SERVICE_URL from "../../../../config/API_DATA";
// import cMLSearch from "../multiCity/search/cMLSearch";
import { i18n } from "../../../../plugins/i18n.js";
//import flightDatePicker from "vue-flight-datepicker";
import HotelDatePicker from "vue-range-datechooser";
import Multiselect from "vue-multiselect";
import { GroupByList, cloneData, cloneDeep } from "../../../../util/util.js";
import { mapGetters, mapActions } from "vuex";
Vue.use(VueNumberInput);
import cHelpTip from "./../../../cHelpTip";

export default {
  name: COMPONENT_NAME.C_HOTEL_SEARCH,
  components: {
    // flightDatePicker,
    HotelDatePicker,
    Multiselect,
    cCurrencyDropDown,
    cOrgCurrencyDp,
    cRadioButton,
    // cMLSearch,
    cHelpTip,
  },
  props: {
    isBackdropAdded: {
      type: Boolean,
      default: false,
    },
    searchObject: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
    clientCode: BaseConfiguration.clientCode,
    allClientCode: ALL_CLIENT_CODE,
    hotelSearch: {
      date: {
        checkInDate: new Date(),
        checkOutDate: new Date(),
      },
      areaObj: {
        // cityCode: null,
        cityName: null,
        airportCode: null,
        // countryCode: null,
        longitude: null,
        latitude: null,
      },
      currencyObj: null,
      roomCount: 1,
      guestList: [
        {
          adult: 1,
          child: 0,
          infant: 0,
        },
      ],
    },
    isMLSearch: false,
    citizenObj: null,
    isFlIconRotate: false,
    isPaxViewOpen: false,
    isDatePicShow: true,

    lsCitizenCategory: [
      {
        name: i18n.tc("searchPage.yes"),
        code: "Y",
      },
      {
        name: i18n.tc("searchPage.no"),
        code: "N",
      },
    ],

    lsAirlineClass: [
      {
        name: i18n.tc("searchPage.economy"),
        code: "E/PE",
      },
      {
        name: i18n.tc("searchPage.buisness"),
        code: "B",
      },
      {
        name: i18n.tc("searchPage.buisFirst"),
        code: "B/F",
      },
      {
        name: i18n.tc("searchPage.premium"),
        code: "PE",
      },
      {
        name: i18n.tc("searchPage.first"),
        code: "F",
      },
    ],

    jTypeTabs: [
      {
        name: i18n.tc("searchPage.oneWay"),
        code: TRIP.ONE_WAY,
      },
      {
        name: i18n.tc("searchPage.roundTrip"),
        code: TRIP.ROUND_TRIP,
      },
      {
        name: i18n.tc("searchPage.multiCity"),
        code: TRIP.MULTI_CITY,
      },
    ],
    lsCitizen: {
      CITIZEN: {
        name: i18n.tc("searchPage.citizenName"),
        code: BaseConfiguration.defaultCountryValue,
      },
      FOREIGNER: {
        name: i18n.tc("searchPage.foreigner"),
        code: CITIZEN.FOREIGNER.code,
      },
      //  CANADIAN :{
      //     name: i18n.tc('searchPage.citizenName'),
      //     code: CITIZEN.CANADIAN.code
      // },
    },
    roomLength: {
                min: BaseConfiguration.roomLength.min,
                max: BaseConfiguration.roomLength.max
            },
    lsCountryRoute: [],
    lsArrival: [],
    routesResponse: null,
    defaultCurrencyCode: null,
    isHoveringRf: false,
    alertValue: null,
    currentAlertCounter: 0,
    
    search: {
      trip: BaseConfiguration.defaultTrip,
      route: [
        {
          from: null,
          to: null,
          date: new Date(),
        },
      ],
      class: null,
      pax: {
        adultCount: 1,
        childCount: 0,
        infantCount: 0,
      },
      citizen: null,
      currency: null,
    },
    active: false,
            };
  },
  
  watch: {
    isBackdropAdded(newVal, oldVal) {
      if (newVal === false) {
        this.closeAllPopups();
      }
      // if(this.$refs.flightDatePicker.isOpen==false&&this.search.route[1].date==null&&this.search.route[0].date)
      // {
      //    this.getCheckOut();
      // }
    },
  },
  methods: {
    ...mapActions("sHotelSearch", {
      SET_HOTEL_ROUTES_OBJ: "SET_HOTEL_ROUTES_OBJ",
      SET_HOTEL_SEARCH_OBJ: "SET_HOTEL_SEARCH_OBJ"}),

    ...mapActions("sCSearch", {
      SET_ARR_LS: "SET_ARR_LS",
      SET_SEARCH_OBJ: "SET_SEARCH_OBJ",
    }),

    ...mapActions("sCMultiCitySearch", {
      SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",
      SET_IS_ML_SEARCH: "SET_IS_ML_SEARCH",
    }),



    // checkOut(){
    //           return addDays(new Date(search.route[0].date),7);
    // },

    // getCheckOut(){
    //   // if(this.$refs.flightDatePicker.isOpen==false){
    //   //    this.search.route[1].date= addDays(new Date(this.search.route[0].date),7);
    //   //     this.$refs.flightDatePicker.checkOut= this.search.route[1].date;
    //   //      this.isDatePicShow=false;

    //   //         let that = this;
    //   //         setTimeout(function() {
    //   //         that.isDatePicShow = true;
    //   //       },100);
    //   // }
    //   console.log("checkout");
    // },
     getDefaultGuestObj() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getDefaultGuestObj");
                    retValue = {
                      adult: 1,
                      child: 0,
                      infant: 0,
                             };
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getDefaultGuestObj",
                        err.toString(),
                        "getDefaultGuestObj",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
    },

    addRooms(){
        if (
                        this.hotelSearch.guestList.length < BaseConfiguration.multiCityLength.max
                    ) {
                        let guestObj = this.getDefaultGuestObj();
                        this.hotelSearch.guestList.push(guestObj);
                        this.hotelSearch.roomCount=this.hotelSearch.roomCount+1;
                    }
    },

    onRemoveRooms(){
         if (BaseConfiguration.isDebug) console.log("onRemoveFlight");
                    if (
                       this.hotelSearch.guestList.length > BaseConfiguration.roomLength.min
                    ) {
                      this.hotelSearch.roomCount=this.hotelSearch.roomCount-1;
                        this.$delete(this.hotelSearch.guestList, this.hotelSearch.guestList.length - 1);
                    }
    },

    getPaxCount(pGuestLs) {
      let retValue=0;
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxCount");
        for (let i = 0; i < pGuestLs.length; i++) {
             retValue = retValue+
          Number(pGuestLs[i].adult) +
          Number(pGuestLs[i].child) +
          Number(pGuestLs[i].infant);
            
        }
       
        if (retValue == 0) {
          retValue = "";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in getPaxCount",
          err.toString(),
          "getPaxCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPaxDisplayText(pCount,isPax) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPaxDisplayText");
        if(isPax){
        if (pCount == 1) {
          retValue = 'Guest';
        } else {
          retValue = 'Guests';
        }}
        else{
            if (pCount == 1) {
          retValue = 'Room';
        } else {
          retValue = 'Rooms';
        } 
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in getPaxDisplayText",
          err.toString(),
          "getPaxDisplayText",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getMaxPaxCount(pGuestLs) {
      let count = 0;
      if(pGuestLs.adult + pGuestLs.child + pGuestLs.infant < 4) {
        count = 4 -
          (pGuestLs.adult + pGuestLs.child + pGuestLs.infant) +
          pGuestLs.adult + pGuestLs.child + pGuestLs.infant;
      }
     
      return count;
    },
    closeAllPopups() {
      this.isPaxViewOpen = false;
      //this.$refs.flightDatePicker.isOpen = false;
      if (this.$refs.fromCityPicker && this.$refs.toCityPicker) {
        this.$refs.fromCityPicker.deactivate();
        this.$refs.toCityPicker.deactivate();
      }
    },
    closePaxView() {
      this.isPaxViewOpen = false;
    },
    onToggleBackdrop(open) {
      if (BaseConfiguration.isDebug) console.log("onToggleBackdrop");

      this.$root.$emit("toggle_backdrop", open);
    },
    cityPickCustomeLabel(option) {
      return `${option.cityname} — [${option.code}]`;
    },
    ///to change class of city picker
    addCssClass() {
      //
      try {
        if (BaseConfiguration.isDebug) console.log("addCssClass");

        let countryTitleLIst = document.getElementsByClassName(
          "multiselect__option--disabled"
        );
        setTimeout(() => {
          for (let index = 0; index < countryTitleLIst.length; index++) {
            const element = countryTitleLIst[index];
            element.parentNode.classList.add("active");
          }
        }, 100);
      } catch (error) {
        //ignore
      }
    },
    triggerFlightDatePicker() {
      if (BaseConfiguration.isDebug) console.log("triggerFlightDatePicker");

      this.onToggleBackdrop(true);
      this.closePaxView();
      this.addCssClass();
      if (this.$refs.flightDatePicker.isOpen) {
        this.$refs.flightDatePicker.isOpen = false;
      }
    },
    //to focus departure dropdown
    openDatePicker() {
      if (
        this.isBackdropAdded == true &&
        this.hotelSearch.date.checkInDate &&
        this.hotelSearch.date.checkOutDate
      ) {
        this.$refs.flightDatePicker.isOpen = true;
      }
    },
   
   
    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat"),
          ],
          "check-in": formatDate(this.hotelSearch.date.checkInDate, "ddd, MMM DD"),
          // this.$t("flightDatePicker.checkIn"),
          // "check-out":"",
          "check-out": formatDate(
            addDays(new Date(this.hotelSearch.date.checkInDate), 7),
            "ddd, MMM DD"
          ),
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec"),
          ],
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    emitSearchObj() {
      try {
        if (BaseConfiguration.isDebug) console.log("emitSearchObj");
        updateDataEdited(false);
        this.checkAndEmitValidObj(this.hotelSearch, this.isMLSearch);
        // if (this.search.trip != TRIP.MULTI_CITY && !this.isMLSearch) {
        //   this.checkAndEmitValidObj(this.search, this.isMLSearch);
        // } else {
        //   let mlSearchObj = this.getFormattedMlSearchObj(
        //     this.GET_ML_SEARCH_OBJ,
        //     this.search
        //   );
        //   this.checkAndEmitValidObj(mlSearchObj, this.isMLSearch);

        // }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error while emitting search object",
          err.toString(),
          "emitSearchObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    checkAndEmitValidObj(pSearchObj, isMLSearch) {
      try {
        if (BaseConfiguration.isDebug) console.log("checkAndEmitValidObj");

        if (this.isValidSearch(pSearchObj)) {
          // let formattedSearchObj = this.formatSearchObjCitizen(pSearchObj);
          this.SET_HOTEL_SEARCH_OBJ(pSearchObj);
          
            this.SET_IS_ML_SEARCH(false);
         

          this.storeSearchHistory(pSearchObj, new Date());
          this.$emit("send", pSearchObj, isMLSearch);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in checkAndEmitValidObj",
          err.toString(),
          "checkAndEmitValidObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

   

    ///to get currency service url
    getOrgCurrencyServiceURL() {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
        return SERVICE_URL.GET_ORG_CURRENCY;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error while getting currency  service url",
          err.toString(),
          "getCurrencyServiceURL",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    ///to change currency
    onCurrencyChange(selCurrencyObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCurrencyChange");

        this.hotelSearch.currencyObj = selCurrencyObj;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error while changing currency",
          err.toString(),
          "onCurrencyChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    

   

   
    toggleCheckIn() {
      this.$refs.flightDatePicker.checkIn = new Date(this.hotelSearch.date.checkInDate);
      this.$refs.flightDatePicker.checkOut = new Date(this.hotelSearch.date.checkOutDate
      );
    },

  
    // //to navigate to search result page
    // navToResultPage() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("navToResultPage");
    //     this.SET_SEARCH_OBJ(this.search);

    //     if (this.storeSearchHistory(this.search)) {
    //       navigate(
    //         path: PATHNAME.FLIGHTRESULTS
    //         // query: {
    //         //   param: [retSearchResult]
    //         // }
    //       });
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       FILE_NAME.SEARCHPAGE,
    //       "error while navigation",
    //       err.toString(),
    //       "navToResultPage",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    ///to get list of search results from api
    // async getSearchResponse(pSearchObj) {
    //   let retValue;
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getSearchResponse");

    //     let getSearchRequest = apiSearchResult.buildRequest(pSearchObj);

    //     if (getSearchRequest) {
    //       // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
    //       let getSearchResponse = await apiSearchResult.getResponse(
    //         getSearchRequest
    //       );

    //       if (VALIDATE_SUCCESS_RES(getSearchResponse)) {
    //         // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

    //         retValue = getSearchResponse.data.data;
    //       } else {

    //         let error = getErrorMessage(getSearchResponse);

    //                 let isJwt = handleJWT(error);
    //                 if (!isJwt) {
    //                     this.alertValue = getErrorAlertValue(error)
    //                 }

    //       }
    //     }
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.C_HOTEL_SEARCH,
    //       "error in getting response from get search result response API",
    //       err.toString(),
    //       "getSearchResponse",
    //        LOG_TYPE.ERROR
    //     );
    //       Logger.getResponse(body);
    //   }
    //   return retValue;
    // },

   

   
    ///to get departure date
    getFromDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
        this.hotelSearch.date.checkInDate= selectedDate;
        this.onToggleBackdrop(false);
        // console.log(this.$refs.flightDatePicker)
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in getFromDate ",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get arrival date
    getToDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getToDate");
        
          if (selectedDate) {
            this.hotelSearch.date.checkOutDate = selectedDate;
          } else {
            // this.getCheckOut();
            //if( this.$refs.flightDatePicker.isOpen==true){
            this.hotelSearch.date.checkOutDate = addDays(
              new Date(this.hotelSearch.date.checkInDate),
              7
            );
          }
          this.onToggleBackdrop(false);
        
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in getToDate ",
          err.toString(),
          "getToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to get number of routes response from api
    async getRoutesResponse() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

        let getRoutesRequest = apiGetCitiesforHotel.buildRequest();

        if (getRoutesRequest) {
          // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
          let getRouteResponse = await apiGetCitiesforHotel.getResponse(
            getRoutesRequest
          );

          if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store
            retValue = getRouteResponse.data.data;
            this.SET_HOTEL_ROUTES_OBJ(retValue);
          } else {
            let error = getErrorMessage(getRouteResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error while getting response from get Routes response API",
          err.toString(),
          "getRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ///method to get routes for particular country
    getRoutesForHotel() {
      try {
        if (BaseConfiguration.isDebug) console.log("getRoutesForHotel");

       
        let routes = this.routesResponse;
        let countries = [];
        let listOfRoutes = [];

        for (let i = 0; i < Object.values(routes.Country).length; i++) {
         countries.push(Object.values(routes.Country)[i].countrycode)
               
        }

        countries = [...new Set(countries)];

        var routesGrpByList = GroupByList(routes.cityArray, "country", "arrCombination"); ///list of routes grouped by depcode
        for (let i = 0; i < countries.length; i++) {
          for (let j = 0; j < routes.cityArray.length; j++) {
            let lsArrCodes = [];
            if (countries[i] == routes.cityArray[j].country) {
            

              listOfRoutes.push( routes.cityArray[j]); ///list of routes for particular country
            }
          }

          let countryRoute = {
            country: countries[i],
            routeList: listOfRoutes,
          };
          listOfRoutes = [];
          this.lsCountryRoute.push(countryRoute);
        }
        let startCountry = cloneData(this.lsCountryRoute[0]);
        for (let index = 0; index < this.lsCountryRoute.length; index++) {
          const countryObj = this.lsCountryRoute[index];
          if (
            countryObj.country.countrycode ==
            BaseConfiguration.defaultCountryValue
          ) {
            this.lsCountryRoute[0] = countryObj;
            this.lsCountryRoute[index] = startCountry;
            break;
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error while formatting routes",
          err.toString(),
          "getRoutesForHotel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    
   
    // to validate search
    isValidSearch(pSearch) {
      if (BaseConfiguration.isDebug) console.log("isValidSearch");
      try {
        let retValue = false;
        
        if (pSearch && pSearch.areaObj && pSearch.areaObj.cityName && 
        pSearch.areaObj.cityName.code) {
         
                if (this.currencyValidation(pSearch)) {
                  retValue = this.paxValidation(pSearch);
                } else {
                  retValue = false;
                  this.showAlertMessage(this.$t("searchPage.selectCurrency"));
                }
             
        }  else {
          retValue = false;
          this.showAlertMessage(this.$t("searchPage.routeInvalid"));
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in isValidSearch",
          err.toString(),
          "isValidSearch",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to validate a currency(if currency slected or not)
    currencyValidation(pSearch) {
      try {
        if (BaseConfiguration.isDebug) console.log("currencyValidation");

        let retValue;
        if (pSearch.currencyObj) {
          if (pSearch.currencyObj.currency_code) {
            if (pSearch.currencyObj.currency_code.code) {
              retValue = true;
            } else {
              retValue = false;
            }
          } else {
            retValue = false;
          }
        } else {
          retValue = false;
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in currencyValidation",
          err.toString(),
          "currencyValidation",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //to valid pax counts(Adult,child,Infant)
    paxValidation(pSearch) {
      try {
        if (BaseConfiguration.isDebug) console.log("paxValidation");

        let retValue = true;
        let count;
        for (let i = 0; i < pSearch.guestList.length; i++) {
          count=0;
         count = pSearch.guestList[i].adult + pSearch.guestList[i].child +
          pSearch.guestList[i].infant ;
          if(count > 4) {
            retValue = false;
          this.showAlertMessage('Max 4 passengers is allowed per room');
          break;
          }          
        }
        

        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in paxValidation",
          err.toString(),
          "paxValidation",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    // to show alert message
    showAlertMessage(value) {
      try {
        if (BaseConfiguration.isDebug) console.log("showAlertMessage");
        if (value) {
          // this.showAlert = true;
          this.alertValue = value;
          this.currentAlertCounter = BaseConfiguration.defaultAlertCounter;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in showAlertMessage",
          err.toString(),
          "showAlertMessage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    //to store search history in localstorage
    storeSearchHistory(pSearch, pDate) {
      if (BaseConfiguration.isDebug) console.log("storeSearchHistory");
      try {
        let retValue = false;
        let userId;
        if (this.USER_ID) {
          userId = this.USER_ID;
        }
        if (pSearch) {
          //let obj = cloneData(this.search);
          let obj = {
            search: JSON.parse(JSON.stringify(pSearch)),
            searchedDate: pDate,
          };
          let searchHistory = this.getSearchHistory(userId);
          //  for(let i=10;i<=searchHistory.length;i++){
          //    searchHistory.shift();
          //  }
          if (searchHistory) {
            if (
              searchHistory.length >=
              BaseConfiguration.flightSearchHistoryMaxLimit
            )
              searchHistory.shift();
            searchHistory.push(obj);
            setHotelSearchHisToLocal(JSON.stringify(searchHistory), userId);
          }
          retValue = true;
        }
        // else throw "invalid Search";
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_HOTEL_SEARCH,
          "error in storeSearchHistory",
          err.toString(),
          "storeSearchHistory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSearchHistory(pUserId) {
      if (BaseConfiguration.isDebug) console.log("getSearchHistory");
      try {
        let sHistory = [];
        if (pUserId) {
          let history = JSON.parse(getHotelSearchHisFromLocal(pUserId));

          if (history && history.length > 0) {
            sHistory = history;
          }
        }
        return sHistory;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SEARCHPAGE,
          "error in getSearchHistory",
          err.toString(),
          "getSearchHistory",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

   
   
  },

  computed: {
    ...mapGetters("sCMultiCitySearch", {
      GET_ML_SEARCH_OBJ: "GET_ML_SEARCH_OBJ",
    }),
    ...mapGetters("language", {
      lang: "GET_LANGUAGE",
    }),
    ...mapGetters("sCSearch", {
      searchStoreObj: "GET_SEARCH_OBJ",
    }),
    ...mapGetters("sCSearch", {
      arrStoreLs: "GET_ARR_LS",
    }),

    ...mapGetters("sHotelSearch", {
      routeObj: "GET_HOTEL_ROUTES_OBJ",
    }),
    ...mapGetters("sCOrgCurrencyDp", {
      currencyOptions: "GET_CURRENCY_OPTIONS",
    }),
    // ...mapGetters("sDashBoard", {
    //   AGENT_DET: "GET_AGENT_LOGO_DET_RES"
    // })
    ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"
    }),
    ...mapGetters("sDashBoard", {
      USER_ID: "GET_USER_ID",
    }),
  },
  async created() {
    try {
      //var a = document.getElementsByClassName("multiselect__option--disabled");
      //a.parentNode.classList.add("active");
      if (BaseConfiguration.isDebug) console.log("created");

      this.defaultCurrencyCode = BaseConfiguration.defaultCurrencyObj.code;


      if (this.searchObject) {
        this.hotelSearch = cloneDeep(this.searchObject);
      } 
      console.log(this.hotelSearch)

      if (this.routeObj != null) {
        this.routesResponse = this.routeObj;
      } else {
        this.routesResponse = await this.getRoutesResponse();
      }
      if (this.routesResponse != null) {
        this.getRoutesForHotel();
      }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_HOTEL_SEARCH,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};

// script for toggle animation
</script>


<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.test {
  background-color: rgb(167, 195, 218);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #ffffff;
  background-color: #3e2ddd;
  border-color: #0f0096;
}

.radioOptions {
  padding: 5px;
}

.pax {
  background: white;
  right: 0;
  z-index: 3;
  background-color: #fff;
  width: 450px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  box-shadow: 0 8px 10px 0 rgba(15, 41, 77, 0.08);
  padding: 15px 18px;
  position: absolute;
  right: 74px;
  top: calc(100% - 0px);
  padding-top: 0px;
}

.remove-flight-btn-wrap{
  width: 18px;
    height: 18px;
    cursor: pointer;
    position: absolute;
    right: 3px;
    bottom: 90px;
    border: solid 2px #f7776e;
    display: -ms-flexbox;
    display: flex;
    border-radius: 50%;
    padding: 4px;
}
</style>
